module.exports = __webpack_public_path__ + "img/shoutouts.dc74cd21.webp";